import Vue from 'vue'

const EventBus = new Vue()

export const setEvent = (event, data) => EventBus.$emit(event, data)

export default EventBus
